import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AppService } from 'src/app/services/app.service';
@Component({
    selector: 'dialog-entreprise-info',
    templateUrl: 'dialog-entreprise-info.component.html',
    styleUrls: ['dialog-entreprise-info.component.scss']
})
export class EntrepriseInfoDialog implements OnInit {
    constructor(
        private appService: AppService,
        private router: Router,
        private httpClient: HttpClient,
        public dialogRef: MatDialogRef<EntrepriseInfoDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    entreprise;
    siret;

    ngOnInit() {
        this.entreprise = this.data.entreprise;
        this.siret = this.data.siret;
        
        let ccNums = [];
        if (this.entreprise.conventions_collectives.length > 0) {
            this.entreprise.conventions_collectives.forEach(cc => {
                if (!cc.nom) {
                    ccNums.push(cc.idcc);
                }
            });
        }

        if (ccNums.length > 0) {
            this.appService.getCCNames(ccNums).subscribe((res) => {
                let result = res.result.result;
                this.entreprise.conventions_collectives.forEach(cc => {
                    for (const [ccNum, nom] of Object.entries(result)) {
                        if (ccNum == cc.idcc) {
                            cc.nom = nom;
                        }
                    }
                });
            })
        }

        this.httpClient.get('assets/content-sirene.json?v='+window['cobham_version']).subscribe((res) => {
            for (const [key, value] of Object.entries(res)) {
                if (key == this.entreprise.tranche_effectif) {
                    this.entreprise.tranche_effectif = value;
                }
            }
        })
    }

    dismissDialog(option = true){
        this.dialogRef.close(option);
    }

}